import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Service global pour toutes les données du dashboard prospects
export const getProspectDashboardData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    if (!token) {
      throw new Error('Token d\'authentification manquant');
    }

    // Appels parallèles pour récupérer toutes les données du dashboard
    const [overviewResponse, sourcesResponse, evolutionResponse, commercialActivityResponse] = await Promise.all([
      axios.get(`${API_BASE_URL}/api/prospects/overview`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      }),
      axios.get(`${API_BASE_URL}/api/prospects/sources`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      }),
      axios.get(`${API_BASE_URL}/api/prospects/evolution`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      }),
      axios.get(`${API_BASE_URL}/api/prospects/commercial-activity`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`
        }
      })
    ]);

    return {
      overview: overviewResponse.data,
      sources: sourcesResponse.data,
      evolution: evolutionResponse.data,
      commercialActivity: commercialActivityResponse.data,
    };
  } catch (error) {
    console.error("Error fetching prospect dashboard data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données d'overview (pour compatibilité)
export const getOverviewData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/prospects/overview`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching overview data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données des sources
export const getSourcesData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/prospects/sources`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching sources data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données d'évolution
export const getEvolutionData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/prospects/evolution`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching evolution data:", error);
    throw error;
  }
};

// Fonction spécifique pour les données d'activité commerciale
export const getCommercialActivityData = async () => {
  try {
    const token = JSON.parse(localStorage.getItem('pocketbase_auth'))?.token;
    
    const response = await axios.get(`${API_BASE_URL}/api/prospects/commercial-activity`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching commercial activity data:", error);
    throw error;
  }
};
